import axios from "axios";
import environment from "../environments/environment";

let BASE_URL = environment.api.host;

const ProviderService = {
  getCuds: async (pickupPointId, carPlate) => {
    console.log("GETCUDS");
    console.log("pickupPointId", pickupPointId);
    console.log("carPlate", carPlate);

    const { data } = await axios.get(`${BASE_URL}/cud?status=unreceived`, {
      params: {
        pickupPointId,
        carPlate,
      },
    });
    console.log(data);
    return data.cuds;
  },
  getCudsReturned: async (pickupPointId, carPlate) => {
    console.log("GETCUDS");
    console.log("pickupPointId", pickupPointId);
    console.log("carPlate", carPlate);

    const { data } = await axios.get(`${BASE_URL}/cud?status=returned`, {
      params: {
        pickupPointId,
        carPlate,
      },
    });
    console.log(data);
    return data.cuds;
  },
  getBeforeSession: async (pickupPointId, userId) => {
    console.log("pickupPointId!!!", pickupPointId);
    console.log("userId!!!", userId);
    const { data } = await axios.get(
      `${BASE_URL}/reception-session/before-session`,
      {
        params: {
          pickupPointId,
          userId,
        },
      }
    );
    if (data.beforeSession != null) {
      console.log("data.beforeSession", data.beforeSession);
      return data.beforeSession;
    }
    return [];
  },
  getDevolutionCuds: async (pickupPointId, carPlate) => {
    const { data } = await axios.get(`${BASE_URL}/cud?status=toreturn`, {
      params: {
        pickupPointId,
        carPlate,
      },
    });
    return data.cuds;
  },

  getReturnCuds: async (pickupPointId, carPlate) => {
    const { data } = await axios.get(`${BASE_URL}/cud?status=returned`, {
      params: {
        pickupPointId,
        carPlate,
      },
    });
    return data.cuds;
  },

  getCarplates: async () => {
    const { data } = await axios.get(`${BASE_URL}/oc/carplate`);
    return data.carplates;
  },

  getCarplatesByStatus: async (status) => {
    const { data } = await axios.get(
      `${BASE_URL}/oc/carplate?status=${status}`
    );
    return data.carplates;
  },

  getOperators: async () => {
    const { data } = await axios.get(`${BASE_URL}/operator`);
    return data.operators;
  },

  //Solo muestra los que tengan isIntegrate true
  getOperatorsReturn: async () => {
    const { data } = await axios.get(`${BASE_URL}/operator`);
    return data.operators.filter((operator) => !operator.isIntegrate);
  },

  getOperatorByPlate: async (carPlate) => {
    console.log(carPlate);
    const { data } = await axios.get(
      `${BASE_URL}/operator?carPlate=${carPlate}`
    );
    return data.operators;
  },

  getPickupsByPlateAndOp: async (carPlate, operatorId) => {
    const { data } = await axios.get(
      `${BASE_URL}/pickup-point?carPlate=${carPlate}&operatorIds=${operatorId}`
    );
    return data.pickupPoints;
  },

  getPickupsByOp: async (operatorId) => {
    const { data } = await axios.get(
      `${BASE_URL}/pickup-point?operatorIds=${operatorId}`
    );
    return data.pickupPoints;
  },

  getUbicationCuds: async (pickupPointId) => {
    const { data } = await axios.get(
      `${BASE_URL}/cud?pickupPointId=${pickupPointId}&status=received`
    );
    return data.cuds;
  },

  getPickupsByPlate: async (plate) => {
    const { data } = await axios.get(
      `${BASE_URL}/pickup-point/carplate/${plate}`
    );
    return data;
  },

  getCudsCount: async (pickupPointId) => {
    const { data } = await axios.get(`${BASE_URL}/cud/count`, {
      params: {
        pickupPointId,
      },
    });
    return data;
  },

  getOcsByDni: async (search, pickupPointId) => {
    const { data } = await axios.get(`${BASE_URL}/oc?status=completed`, {
      params: {
        pickupPointId,
        search,
      },
    });
    return data.purchaseOrders;
  },

  getQueryOcs: async (pickupPointId) => {
    const { data } = await axios.get(`${BASE_URL}/oc?status=completed`, {
      params: {
        pickupPointId,
      },
    });
    return data.purchaseOrders;
  },

  getCudsByOc: async (oc) => {
    const { data } = await axios.get(`${BASE_URL}/oc/${oc}/cud`);
    return data.cuds;
  },

  putCuds: async (cud, status) => {
    const response = await axios.put(`${BASE_URL}/cud/update`, {
      id: cud.id,
      type: cud.type,
      cud: {
        receptionSessionId: cud.sessionId,
        status,
        placeId: cud.location,
        evidenceImage: cud.photo,
        finalized: false,
      },
    });
    return response;
  },

  postReturnOrderCd: async ({ dni, name, cuds }) => {
    const body = { dni, name, cuds };

    try {
      const { data } = await axios.post(`${BASE_URL}/cud/returnOrderCD`, body);
      console.log("SUCCESS_RETURN_ORDER_CD: ", data);
      return data;
    } catch (error) {
      console.log("ERROR_RETURN_ORDER_CD: ", error);
      return null;
    }
  },

  putCudsReturn: async (cud, status) => {
    const { data } = await axios.put(`${BASE_URL}/cud/update`, {
      id: cud.id,
      type: cud.type,
      onlyReturn: status === "returned",
      cud: {
        status,
        placeId: cud.location,
        toReturnImage: cud.photo,
        receptionSessionId: cud.sessionId,
      },
    });
    return data;
  },

  putCudsReturned: async (cud, status) => {
    const { data } = await axios.put(`${BASE_URL}/cud/update`, {
      id: cud.id,
      type: cud.type,
      onlyReturn: status === "receptionCDLI",
      cud: {
        status,
        placeId: cud.location,
        evidenceCDLI: cud.photo,
        receptionSessionId: cud.sessionId,
      },
    });
    return data;
  },

  updateUbication: async (cud, inLocationImage) => {
    console.log("this is cud in provider:", cud);
    const { data } = await axios.put(`${BASE_URL}/cud/update`, {
      id: cud.id,
      type: cud.type,
      cud: {
        status: "received",
        placeId: cud.location,
        inLocationImage,
      },
    });
    return data;
  },

  getReceptionSession: async (type, pickupPointId, userId) => {
    const {
      data: {
        receptionSession: [session],
      },
    } = await axios.post(`${BASE_URL}/reception-session`, {
      receptionSession: { type, pickupPointId, userId },
    });
    return session.id;
  },

  getSessionStatus: async (id) => {
    const {
      data: { cuds },
    } = await axios.get(`${BASE_URL}/reception-session/${id}/cud`);

    return cuds;
  },

  finalizeSession: async ({ sessionId, charger, image }) => {
    const { data, status } = await axios.put(
      `${BASE_URL}/reception-session/finalize`,
      {
        receptionSession: {
          id: sessionId,
          employeeName: charger.name,
          employeeDni: charger.dni,
          sign: image,
        },
      }
    );
    return { data, status };
  },

  finalizeSessionReturn: async ({ sessionId, charger, image, type }) => {
    const { data, status } = await axios.put(
      `${BASE_URL}/reception-session/finalize`,
      {
        receptionSession: {
          id: sessionId,
          employeeName: charger.name,
          employeeDni: charger.dni,
          sign: image,
          type,
        },
      }
    );
    return { data, status };
  },

  deleteSession: async (id) => {
    const { data } = await axios.delete(`${BASE_URL}/reception-session/${id}`);
    return data;
  },

  getPlaces: async () => {
    const {
      data: { places },
    } = await axios.get(`${BASE_URL}/place`);
    return places;
  },

  getUbications: async (userId) => {
    const { data } = await axios.get(`${BASE_URL}/user/${userId}/pickup-point`);
    return data.pickupPoints;
  },

  finalizeOc: async (id, deliveredImage, clientPhoto, sign) => {
    const body = {
      id,
      purchaseOrder: {
        status: "completed",
        deliveredImage,
        clientPhoto,
        sign,
      },
    };
    console.log(body);
    const { data } = await axios.put(`${BASE_URL}/oc/update`, body);
    // await new Promise(resolve => {
    //   setTimeout(resolve, 1500)
    // })

    return data;
  },

  getCudByCarton: async (carton) => {
    const { data } = await axios.get(`${BASE_URL}/search/${carton}`);
    return data.cud;
  },
};

export default ProviderService;
